import { takeEvery, call, put } from 'redux-saga/effects'
import { showAlertError } from '../../../store/Alert/actions'
import axios from 'axios'
import { LOAD_VIDEO_REPORT, loading, putVideoReport } from '../../../store/Reports/Video/actions'

export default function* () {
    yield takeEvery(LOAD_VIDEO_REPORT, worker)
}

function* worker({ payload }) {
    yield put(loading(true))
    try {
        let video_report = yield call(fetchVideoReport, payload)
        if (video_report.error?.length) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${LOAD_VIDEO_REPORT}.`, video_report],
                text: "Отчет не был загружен. Попробуйте перезагрузить страницу."
            }))
            yield put(putVideoReport([]))
        } else if (video_report.success?.length) {
            const idSet = new Set(
                video_report.success
                    .map(el => el.clip_id)
                    .filter(id => id && !isNaN(Number(id)))
            )

            const videos = idSet.size
                ? yield call(fetchVideos, [...idSet])
                : { success: [] }

            const videoMap = new Map(videos.success.map(v => [v.id, v]))

            video_report.success = video_report.success.map(el => {
                const id = Number(el.clip_id)
                const video = videoMap.get(id)
                return {
                    ...el,
                    cliptime: video?.cliptime || 0,
                    mimetype: video?.mimetype,
                    invalid: isNaN(id) || !id
                }
            })

            yield put(putVideoReport({ video_report: video_report.success }))
        } else {
            yield put(putVideoReport({ video_report: [] }))
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_VIDEO_REPORT}.`, e],
            text: "Отчет не был загружен. Попробуйте перезагрузить страницу."
        }))
        yield put(putVideoReport([]))
    }
    finally {
        yield put(loading(false))
    }
}

function fetchVideoReport(search) {
    return axios.get("/msbox/report/video", { params: { id: search.id, date: search.date } })
        .then(response => response.data)
}

function fetchVideos(ids) {
    return axios.get(`videolist/tracks/search?${ids.map(id => `id[]=${id}`).join("&")}`)
        .then(response => response.data)
}